import { render, staticRenderFns } from "./Assigner.vue?vue&type=template&id=38d0343a&scoped=true"
import script from "./Assigner.vue?vue&type=script&lang=js"
export * from "./Assigner.vue?vue&type=script&lang=js"
import style0 from "./Assigner.vue?vue&type=style&index=0&id=38d0343a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d0343a",
  null
  
)

export default component.exports